export default __webpack_public_path__ + "static/media/bg.22307c53.png";